export const HORIZONTAL_SCROLLER_SCROLL_DEBOUNCE_WAIT_MSEC = 10;
export const HORIZONTAL_SCROLLER_SCROLLEND_TOLERANCE = 10;
